import {
  CommunicationContextType,
  ComposeContextRowType,
  ComposeContextValueKind
} from '../../../lib/types/communication.types';

// Registry of selectable row kinds, in menu order. Display labels resolve per
// company in context-selector.messages.tsx — never hardcode a sport word here.
export const CONTEXT_ROW_TYPES: ComposeContextRowType[] = [
  CommunicationContextType.AGE_GROUP,
  CommunicationContextType.ASSESSMENT_SESSION,
  ComposeContextValueKind.LEVEL,
  ComposeContextValueKind.TEAM,
  CommunicationContextType.PLAYER_ASSESSMENT
];
